export const Divider = () => {
  return <div className="my-1 h-px w-full bg-divider" />
}
